export interface ResolveLanguageInput {
	urlLang: string | null | undefined;
	scriptLang: string | null | undefined;
	clientLang: string | null | undefined;
	multilingual: boolean | null | undefined;
	navigatorLang: string | null | undefined;
	supported: readonly string[];
}

const FALLBACK = 'es';

const normalize = (raw: string | null | undefined): string | null => {
	if (!raw) return null;
	return raw.toLowerCase().split('-')[0];
};

const pickSupported = (candidate: string | null, supported: readonly string[]): string | null => {
	if (!candidate) return null;
	return supported.includes(candidate) ? candidate : null;
};

export const resolveLanguage = (input: ResolveLanguageInput): string => {
	const { urlLang, scriptLang, clientLang, multilingual, navigatorLang, supported } = input;
	const fromUrl = pickSupported(normalize(urlLang), supported);
	if (fromUrl) return fromUrl;
	if (urlLang && !fromUrl) {
		console.warn(`[resolveLanguage] "${urlLang}" is not a supported locale, falling back`);
	}
	const fromScript = pickSupported(normalize(scriptLang), supported);
	if (fromScript) return fromScript;
	if (scriptLang && !fromScript) {
		console.warn(`[resolveLanguage] "${scriptLang}" is not a supported locale, falling back`);
	}
	if (multilingual) {
		const fromNavigator = pickSupported(normalize(navigatorLang), supported);
		if (fromNavigator) return fromNavigator;
	}
	const fromClient = pickSupported(normalize(clientLang), supported);
	if (fromClient) return fromClient;
	return FALLBACK;
};
